const files = require.context(
  '@stone-payments/jade-design-tokens/status-tracker',
  false,
  /.svg$/
)

export const STATUS_TRACKER_ICONS_LIST = files
  .keys()
  .map(key => key.slice(2, -4))
